module.exports = __webpack_public_path__ + "img/orange_056.b10752a4.png";